import PropTypes from 'prop-types'
import React from 'react'

import HeadBanner from '../banners/headBanner'
import CategoriesMenu from './categoriesMenu'
import MarketSiteMenu from './marketSiteMenu'
import GlobalHeader from './globalHeader'

class SiteHeader extends React.Component {
  static propTypes = {
    currentSite: PropTypes.string.isRequired,
    toggleOffCanvas: PropTypes.func.isRequired,
    menuConfig: PropTypes.array.isRequired,
    user: PropTypes.object
  }

  toggleOffCanvasNav (direction, event) {
    event.preventDefault()
    this.props.toggleOffCanvas(direction)
  }

  render () {
    let { currentSite, user, menuConfig, banners } = this.props

    return (
      <div className='canvas__header'>
        <HeadBanner banners={banners} />
        <header className='site-header'>
          <div className='site-header__mini fds-u-hide-extra-large-and-above'>
            <div className='header-mini'>
              <div className='header-mini__button--account'>
                <a href='#account' className='btn-square' onClick={this.toggleOffCanvasNav.bind(this, 'right')}>
                  <i className='e-icon -icon-person' />
                  <span className='fds-u-is-hidden'>Account</span>
                </a>
              </div>

              <div className='header-mini__button--categories'>
                <a href='#categories' className='btn-square' onClick={this.toggleOffCanvasNav.bind(this, 'left')}>
                  <i className='e-icon -icon-hamburger' />
                  <span className='fds-u-is-hidden'>Sites, Search &amp; Categories</span>
                </a>
              </div>

              <div className='header-mini__logo'>
                <a href='/' className={`header-mini__logo--${currentSite}`}>{currentSite}</a>
              </div>
            </div>

          </div>

          <GlobalHeader currentSite={currentSite} user={user} />

          <MarketSiteMenu currentSite={currentSite} />

          <div className='site-header__categories fds-u-hide-extra-large-and-below'>
            <div className='header-categories'>
              <div className='grid-container -layout-wide'>
                <CategoriesMenu items={menuConfig} />
              </div>
            </div>
          </div>
        </header>
      </div>
    )
  }
}

export default SiteHeader



// WEBPACK FOOTER //
// ./client/components/siteHeader/index.js